import { Container, Text, useDateFormat } from 'react-common'
import { useTranslation } from 'react-i18next'
import { useIsMobile } from '@/hooks/useIsMobile'
import styles from './TOCPluginTitle.module.scss'
import { TOCPluginProgress } from '../TOCPluginProgress/TOCPluginProgress'

type Props = {
  name?: string
  progress?: number
  dueDate?: string
}

export const TOCPluginTitle = ({ name, progress, dueDate }: Props) => {
  const { t } = useTranslation()
  const isMobile = useIsMobile()
  const { formatDateTime } = useDateFormat()

  return (
    <div className={styles.wrapper}>
      <Container bottomPadding={isMobile ? Container.Padding.p16 : Container.Padding.p8}>
        <Text.Body2Medium>{name}</Text.Body2Medium>
      </Container>
      <TOCPluginProgress progress={progress} />
      {dueDate && (
        <Container topPadding={Container.Padding.p10}>
          <Text.Caption2 className={styles.dueDate}>
            <span>{t('compositions.dueDate')}</span>&nbsp;<span>{formatDateTime(dueDate)}</span>
          </Text.Caption2>
        </Container>
      )}
    </div>
  )
}
